import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { handleSumVotes, livePoll } from "helpers";
import { IPortraitPollOptionsProps } from "interfaces";
import { shallowEqual } from "react-redux";

const PortraitPollOption = ({ option, lastOptionId, sumVotes }: IPortraitPollOptionsProps) => {
    const { question, selectedOptionId } = useAppSelector(
        ({ videoData: { question, selectedOptionId } }) => ({ question, selectedOptionId }),
        shallowEqual
    );

    const [voteWidth, setVoteWidth] = useState<number>(0);
    const [voteCount, setVoteCount] = useState<number>(0);

    const handleVoteWidth = (vote: number, id: number) => {
        let notUpdateVote = [];
        let sumPercent = 0;
        let sumVotes = handleSumVotes(question);
        if (livePoll())
            notUpdateVote = livePoll().polls.filter((poll: any) => poll.qid === question.id && poll.oid === id && poll.sumOptionVotes === vote + 1);
        setVoteCount(notUpdateVote.length > 0 ? vote + 1 : vote);
        if (option.id === lastOptionId) {
            if (vote === 0 && notUpdateVote.length === 0) return 0;
            let otherUpdatedVote: any = [];
            question.options.forEach((option: any) => {
                if (option.id !== lastOptionId) {
                    if (livePoll())
                        otherUpdatedVote = livePoll().polls.filter(
                            (poll: any) => poll.qid === question.id && poll.oid === option.id && poll.sumOptionVotes === option.vote + 1
                        );
                    sumPercent =
                        sumPercent + Math.floor(sumVotes ? ((otherUpdatedVote.length > 0 ? option.vote + 1 : option.vote) * 100) / sumVotes : 0);
                    otherUpdatedVote = [];
                }
            });
            return 100 - sumPercent;
        } else return sumVotes ? ((notUpdateVote.length > 0 ? vote + 1 : vote) * 100) / sumVotes : 0;
    };

    useEffect(() => {
        setVoteWidth(handleVoteWidth(option.vote, option.id));
    }, [option.vote, selectedOptionId, sumVotes]);

    return (
        <div className="pl-flex pl-justify-between pl-items-center pl-gap-2" key={option.id}>
            <div className="pl-relative pl-grow pl-w-auto pl-break-all">
                <p className="pl-text-[13px] pl-font-medium pl-px-3 pl-py-2 pl-rounded-[4px] pl-cursor-default">
                    <span>{option.text}</span>
                    <span className="pl-mr-1">({voteCount} نفر)</span>
                </p>
                <div
                    className={`pl-absolute pl-top-0 pl-right-0 pl-h-full pl-w-0 pl-bg-purple-light/[0.3] pl-rounded-[8px]`}
                    style={{ width: `${Math.floor(voteWidth)}%` }}
                />
            </div>
            <p className="pl-text-[13px] pl-font-medium pl-w-[30px] pl-text-left">{`${Math.floor(voteWidth).toFixed(0)}%`}</p>
        </div>
    );
};

export default PortraitPollOption;
